import gql from 'graphql-tag';
export default gql`
  mutation getWetSignatureUrl($applicationId: String!, $wetSignatureObjName: String!) {
    getWetSignatureUrl(applicationId: $applicationId, wetSignatureObjName: $wetSignatureObjName) {
      files {
        url
        fileName
      }
    }
  }
`;
